module.exports = __webpack_public_path__ + "img/韩伟.f210ba0a.jpg";